import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRouter from "./PrivateRouter";
import { Login } from "../pages/Login";

const RootRouter: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={<PrivateRouter />} />
    </Routes>
  </BrowserRouter>
);

export default RootRouter;
